import * as React from 'react'
import { Link } from 'react-navi'
import { Cookie } from 'src/utils/cookie'

import './activity_info.scss'

import { IProps, IState } from './interface'

class ActivityInfo extends React.Component<IProps, IState> {
    private timer: number

    constructor(props: IProps) {
        super(props)
        this.state = {
            data: {
                count: props.data.count,
                url: props.data.url,
                time: this.formatRestTime(props.data.time)
            }
        }
        this.countDown(props.data.time)
    }

    public componentWillReceiveProps = (nextProps: IProps) => {
        this.setState({
            data: {
                count: nextProps.data.count,
                url: nextProps.data.url,
                time: this.formatRestTime(nextProps.data.time)
            }
        }, () => {
            this.countDown(nextProps.data.time)
        })
    }

    public componentWillUnmount = () => {
        this.timer && window.clearInterval(this.timer)
    }

    public render = () => {
        const { count, url, time } = this.state.data
        return (
            !!time ?
                <div className="activity-info">
                    <div>
                        {(!!Cookie.get() || !!Cookie.get(Cookie.WECHATIDKEY)) && <div className="rest-count">
                            剩余可投票机会
                            <span className="count"> {count > 0 ? count : 0}</span>
                        </div>}
                        <Link className="rule" href={url}>查看投票规则</Link>
                        <div className="count-down">{`剩余投票时间 ${time}`}</div>
                    </div>
                </div> :
                <div className="activity-info">
                    <div className="ended">当前投票已截止</div>
                </div>
        )
    }

    private formatRestTime = (timestamp: number) => {
        const nowDate = new Date().getTime()
        const dValue = timestamp * 1000 - nowDate
        let day = 0
        let hour = 0
        let minute = 0
        let second = 0
        if (dValue > 0) {
            day = Math.floor(dValue / 1000 / 60 / 60 / 24)
            hour = Math.floor(dValue / 1000 / 60 / 60 - (24 * day))
            minute = Math.floor(dValue / 1000 / 60 - (24 * 60 * day) - (60 * hour))
            second = Math.floor(dValue / 1000 - (24 * 60 * 60 * day) - (60 * 60 * hour) - (60 * minute))
            return `${day}天${hour}小时${second}秒`
        } else {
            this.timer && window.clearInterval(this.timer)
            return ''
        }
    }

    private countDown = (timestamp: number) => {
        this.timer && window.clearInterval(this.timer)
        this.timer = window.setInterval(() => {
            const activityInfo = this.state.data
            activityInfo.time = this.formatRestTime(timestamp)
            this.setState({
                data: activityInfo
            })
        }, 1000)
    }
}

export {
    ActivityInfo
}


// WEBPACK FOOTER //
// ./src/components/common/activity_info/activity_info.tsx